import './NewBadge.css'

const NewBadge = () => (
  <div className="new-badge" aria-label="جديدنا NEW">
    <img
      src="/img/new-badge-brush.png"
      alt=""
      className="new-badge-brush"
      draggable={false}
      aria-hidden="true"
    />
    <div className="new-badge-text">
      <span className="new-badge-en">NEW</span>
      <span className="new-badge-ar">جديدنا</span>
    </div>
  </div>
)

export default NewBadge
